import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { GetVerifyButtonProps } from '../types'

export const getVerifyButton = ({ t, onClick }: GetVerifyButtonProps) =>
  ({
    label: t('secureConnection.verifyToken.buttons.verify'),
    onClick: onClick,
  } as Action)
